import {MetaTitleDesc} from "./meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Выставки';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>Большое значение для развития межрегиональных связей играет ежегодно проводимая многоотраслевая
                        выставка-ярмарка «Брест. Содружество». Выставка проводится уже седьмой год подряд и с каждым
                        годом количество ее участников из Республики Беларусь, России, Украины, Польши и других
                        государств растет.</p>
                </div>
            </div>
        </>
    );
}